import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import administrationsComponent from './admins-by-category-bar.component';
import adminsByCategoryService from './admins-by-category-bar.service';

export default
  angular.module('components.reports.administrationsByCategoryBar', [
    uiRouter
  ])
    .component('administrationsByCategoryBar', administrationsComponent)
    .service('AdminsByCategoryBarService', adminsByCategoryService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('administrationsByCategoryBar', {
          parent: 'reports',
          url: '/administrations-by-category-bar',
          component: 'administrationsByCategoryBar',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-bar/admins-by-category-bar.module.js